module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Last-Week-Tonight.3790b5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Last-Week-Tonight.jpg
// module id = lzyE
// module chunks = 0